/**
 * Creates a promise with its resolve and reject functions exposed.
 * This is useful when you need to resolve or reject a promise from outside its executor.
 * @util
 *
 * @template T - The type of value the promise will resolve with
 * @returns An object containing:
 *   - `promise`: The created Promise
 *   - `resolve`: Function to resolve the promise with a value of type T
 *   - `reject`: Function to reject the promise with an error
 *
 * @example
 * ```ts
 * const { promise, resolve, reject } = createPromise<string>();
 *
 * // Later...
 * resolve("Hello World");
 * // or
 * reject(new Error("Something went wrong"));
 * ```
 */
export function createPromise() {
    let resolve;
    let reject;
    const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
    });
    return {
        promise,
        resolve,
        reject,
    };
}
//# sourceMappingURL=createPromise.js.map